import { UnavailabilityError } from 'expo-modules-core';

export default function BannerAd() {
  throw new UnavailabilityError('expo-ads-facebook', 'BannerAd');
}
